// extracted by mini-css-extract-plugin
export default {"loginButton":"LoginButton_loginButton__mt4v2"};